import {API_URL} from '../../../constants'

/**
 * Compose the FR training-photo image URL for a person.
 *
 * The `clientid` query param is REQUIRED — the faces service scopes the
 * training photo to the client, so a missing/blank clientid yields a 4xx. This
 * lives in one place so the URL shape and its required param can't drift across
 * call sites (e.g. an <img src> in the FR-confidence modal).
 */
export const buildTrainingPhotoImageUrl = (
  personId: number,
  clientId: number,
): string =>
  `${API_URL}/v2/faces/training-photos/${personId}/image?clientid=${clientId}`
